import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import IntroTemplate from './IntroTemplate';
import { precacheImages } from '../../redux/Precache/actions';

class Intro extends PureComponent {
  componentWillMount() {
    if (typeof window === 'undefined') {
      return;
    }

    this.props.precacheImages(['/main/background.jpg']);
  }

  render() {
    return (
      <IntroTemplate />
    );
  }
}

Intro.propTypes = {
  precacheImages: PropTypes.func.isRequired
};

export default connect(null, {
  precacheImages
})(Intro);



// WEBPACK FOOTER //
// ./src/components/Intro/index.js